import { Navigate, Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useUser } from './context/UserContext';
import { useAccess } from './hooks/useAccess';

export default function PrivateRoutes() {
  const { isAuthenticated, isReady, role } = useUser();
  const location = useLocation();
  const navigate = useNavigate();
  const prevRoleRef = useRef(null);
  const { canAccess } = useAccess();

  // Role change detection
  useEffect(() => {
    if (!role) return;
    if (prevRoleRef.current && prevRoleRef.current !== role) {
      alert('Your session configuration has been updated. The page will reload.');
      setTimeout(() => window.location.reload(), 200);
      return;
    }
    prevRoleRef.current = role;
  }, [role]);

  // Role-based route redirects
  useEffect(() => {
    if (!role) return;

    // Route a Super Admin automatically away from standard user views to their dedicated board
    if (role === 'super-admin' && location.pathname === '/dashboard') {
      navigate('/admin/dashboard', { replace: true });
    }
  }, [location.pathname, role, navigate]);

  if (!isReady) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace={true} state={{ from: location }} />;

  // Map of paths to Centralized Policy Strings instead of raw api keys
  const routePoliciesMap = {
    '/users': 'ManageTeam',
    '/admin/dashboard': 'ViewReports',
    '/admin/roles-permissions': 'ManageRolesAndPermissions',
    '/settings': 'ManageOrgSettings',
  };

  const currentPath = location.pathname;
  const requiredPolicy = routePoliciesMap[currentPath];

  if (requiredPolicy && !canAccess(requiredPolicy)) {
    return <Navigate to="/unauthorized" replace={true} />;
  }

  return <Outlet />;
}